// extracted by mini-css-extract-plugin
export default {"resultPage":"ResultPage_resultPage__hlMcO","fadeIn":"ResultPage_fadeIn__DEBZk","btn":"ResultPage_btn__IvUat"};